module.exports = __webpack_public_path__ + "img/about-icon-2.d22ac038.png";